<template>
	<div id="signForm">
		<Form ref="signForm" :model="signForm" :rules="ruleValidate">
			<FormItem prop="sPhone">
				<Input prefix="md-person" size="large" v-model="signForm.sPhone" placeholder="输入手机号"></Input>
			</FormItem>
			<FormItem prop="sDXCode">
				<Input prefix="md-mail" size="large" v-model="signForm.sDXCode" placeholder="输入短信验证码"
					class="codeInput"></Input>
				<Button type="primary" ghost class="codeBtn" @click="getCode" size="large"
					:disabled="isgain">{{codeText}}</Button>
			</FormItem>
			<FormItem prop="sPwd">
				<Input prefix="md-lock" size="large" v-model="signForm.sPwd" type="password"
					placeholder="密码 8-18位必须包含字母和数字"></Input>
			</FormItem>
			<FormItem prop="sPwdAgain">
				<Input prefix="md-lock" size="large" v-model="signForm.sPwdAgain" type="password"
					placeholder="再次输入密码"></Input>
			</FormItem>
			<FormItem prop="sTXCode" class="verifyCode">
				<Input prefix="md-apps" size="large" v-model="signForm.sTXCode" placeholder="输入图形验证码"
					class="codeInput"></Input>
				<div class="codeImg" id="signCode"></div>
			</FormItem>
			<FormItem>
				<Button type="primary" style="background-color:#115467;" size="large" long :loading="loading"
					@click="signSubmit">注册</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
	import {
		userAuthCode,
		userCode,
		userSign,
		userLogin
	} from '../../request/api.js';
	import {
		encrypt
	} from '../../libs/rsaEncrypt.js';
	import {
		GVerify
	} from '../../libs/verifyCode.js';
	export default {
		name: 'sign',
		data() {
			const validatePhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('手机号不能为空'));
				} else if (!/^1[34578]\d{9}$/.test(value)) {
					callback('请输入正确的手机号');
				} else {
					callback();
				}
			};
			const validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('密码不为空'));
				} else {
					var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
					if (value.length < 8) {
						return callback(new Error('密码不能少于8位！'));
					} else if (value.length > 18) {
						return callback(new Error('密码最长不能超过18位！'));
					} else if (pattern.test(value)) {
						return callback(new Error('密码不能包含特殊字符'));
					} else {
						if (this.signForm.sPwdAgain !== '') {
							// 对第二个密码框单独验证
							this.$refs.signForm.validateField('sPwdAgain');
						}
						callback()
					}
				}
			};
			const validatePassCheck = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.signForm.sPwd) {
					callback(new Error('两次密码不一致!'));
				} else {
					callback();
				}
			};
			const validateTXCode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('图形验证码不为空'));
				} else {
					var verifyFlag = this.verify.validate(value);
					if (!verifyFlag) {
						callback(new Error('图形验证码错误!'));
						this.verify.refresh()
					} else {
						callback();
					}
				}
			};
			return {
				verify: null,
				codeUrl: '',
				isgain: false,
				codeText: '获取验证码',
				timer: null,
				signForm: {
					sName: '',
					sPhone: '',
					sDXCode: '',
					sPwd: '',
					sPwdAgain: '',
					sTXCode: '',
					UUid: '',
					txCode: ''
				},
				ruleValidate: {
					sName: [{
						required: true,
						message: '用户名不为空',
						trigger: 'blur'
					}],
					sPhone: [{
						required: true,
						trigger: 'blur',
						validator: validatePhone
					}],
					sDXCode: [{
						required: true,
						message: '短信验证码不为空',
						trigger: 'blur'
					}],
					sPwd: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					sPwdAgain: [{
						required: true,
						validator: validatePassCheck,
						trigger: 'blur'
					}],
					sTXCode: [{
						required: true,
						validator: validateTXCode,
						trigger: 'blur'
					}],
				},
				loading: false
			}
		},
		methods: {
			getCode() {
				const TIME_COUNT = 60;
				this.$refs.signForm.validateField('sPhone', (phoneError) => {
					if (phoneError === '') {
						userCode(this.signForm.sPhone).then(res => {
							if (res.status == undefined) {
								this.$Message.success('短信验证码发送成功!');
								this.signForm.UUid = res;
								if (!this.timer) {
									this.isgain = true;
									this.codeText = TIME_COUNT;
									this.timer = setInterval(() => {
										if (this.codeText > 0 && this.codeText <= TIME_COUNT) {
											this.codeText--;
										} else {
											this.isgain = false;
											this.codeText = '重新获取';
											clearInterval(this.timer);
											this.timer = null;
										}
									}, 1000)
								}
							} else {
								this.$Message.error(res.message);
							}
						})
					}
				});
			},
			signSubmit() {
				this.loading = true;
				this.$refs.signForm.validate((valid) => {
					if (valid) {
						let signData = {
							code: this.signForm.sDXCode,
							password: encrypt(this.signForm.sPwd),
							username: this.signForm.sPhone,
							uuid: this.signForm.UUid
						}
						userSign(signData).then(res => {
							this.loading = false;
							this.$Message.success('注册成功!');
							// this.$router.go(0);
							this.$parent.signIn(false);
						}).catch((err) => {
							this.loading = false;
							this.$Message.error(err.message);
							this.verify.refresh()
						})
					} else {
						this.loading = false;
						this.$Message.error('输入有误!');
					}
				})
			},

		},
		mounted() {
			this.verify = new GVerify('signCode')
		}
	}
</script>

<style>
	#signForm {
		width: 300px;
		margin: 40px auto;
	}

	.verifyCode .ivu-form-item-content {
		display: flex !important;
		flex-direction: inherit;
		align-items: center;
		justity-content: center;
	}

	.verifyEnter {
		width: 60%;
	}

	.codeImg {
		height: 42px;
		width: 39%;
		display: inline-block;
		overflow: hidden;
		margin-left: 1%;
	}
</style>
